import { ApiError, PaginatedResponse } from '@gorila-shared-ui/components';
import { Fence, FenceCore } from '../types/fence';
import { deleteRequest, downloadRequest, getRequest, postRequest } from './api';
import { fenceUrl, fencesFileUrl, fencesUrl } from './urls/fenceUrls';

export const getFences = async (
  clientId: string,
  subClientId: string,
  page: number = 1,
  search: string = ''
): Promise<{ paginatedResponse?: PaginatedResponse<Fence>; error?: ApiError }> => {
  const response = await getRequest(fencesUrl, { queryParams: { clientId, subClientId, page, search } });
  return {
    paginatedResponse: response?.data,
    error: response?.error,
  };
};

export const getFence = async (
  fenceId: string,
  clientId: string,
  subClientId: string
): Promise<{ fence?: Fence; error?: ApiError }> => {
  const response = await getRequest(fenceUrl(fenceId), { queryParams: { clientId, subClientId } });
  return {
    fence: response?.data,
    error: response?.error,
  };
};

export const getFencesFileKey = async (
  clientId: string,
  subClientId: string
): Promise<{ key?: string; error?: ApiError }> => {
  const response = await getRequest(fencesFileUrl, { queryParams: { clientId, subClientId } }, 'text');

  return {
    key: response?.data,
    error: response?.error,
  };
};

export const getFencesFile = async (key: string): Promise<{ file?: Blob; error?: ApiError }> => {
  const response = await downloadRequest(`public/${key}`);

  return {
    file: response?.data?.file,
    error: response?.error,
  };
};

export const deleteFence = async (
  clientId: string,
  subClientId: string,
  fenceId: string
): Promise<{ error?: ApiError }> => {
  const response = await deleteRequest(fenceUrl(fenceId), { queryParams: { clientId, subClientId } });

  return {
    error: response?.error,
  };
};

export const updateFence = async (
  client: string,
  subClient: string,
  fence: FenceCore,
): Promise<{ id?: string; error?: ApiError }> => {
  const { assignedAssets, ...core } = fence;
  const response = await postRequest(fenceUrl(fence._id), {
    body: { ...core, subClientId: subClient, clientId: client, assets: fence.assignedAssets },
  });

  return {
    id: response?.data?.id,
    error: response?.error,
  };
};

export const postFence = async (
  client: string,
  subClient: string,
  fence: FenceCore,
): Promise<{ id?: string; error?: ApiError }> => {
  const { assignedAssets, ...core } = fence;
  const response = await postRequest(fencesUrl, {
    body: { ...core, subClientId: subClient, clientId: client, assets: fence.assignedAssets },
  });

  return {
    id: response?.data?._id,
    error: response?.error,
  };
};
